import { common } from '@kurtosys/ksys-app-template';

import { IImageProps } from '../components/base/Image/models/index.js';
import { ILinkProps } from '../components/base/Link/models/index.js';
import { IMorningStarProps } from '../components/base/MorningStar/models/index.js';
import { IDocumentTilesProps } from '../components/file/DocumentTiles/models/IDocumentTilesProps.js';
import { IChangeIndicatorProps } from '../components/overview/ChangeIndicator/models/index.js';
import { IRiskRatingProps } from '../components/risk/RiskRating/models/index.js';
import { IFact } from '../models/IFact.js';
import { IGroupedFactsProps } from '../models/IGroupedFactsProps.js';

export const factHasValue = (fact: IFact): boolean => {
	const {
		dataType,
		changeIndicatorProps = {} as IChangeIndicatorProps,
		riskRatingProps = {} as IRiskRatingProps,
		morningstarRatingProps = {} as IMorningStarProps,
		appAssetProps = {} as IImageProps,
		groupedListProps = {} as IGroupedFactsProps,
		linkProps = {} as ILinkProps,
		documentTilesProps = {} as IDocumentTilesProps,
		value,
	} = fact;
	if (dataType === 'change-indicator') {
		return (
			!common.commonUtils.isNullOrUndefined(changeIndicatorProps) &&
			!common.commonUtils.isNullOrEmpty(changeIndicatorProps.value)
		);
	}
	if (dataType === 'risk-rating') {
		return (
			!common.commonUtils.isNullOrUndefined(riskRatingProps) &&
			!common.commonUtils.isNullOrEmpty(riskRatingProps.value)
		);
	}
	if (dataType === 'morningstar-rating') {
		return (
			!common.commonUtils.isNullOrUndefined(morningstarRatingProps) &&
			!common.commonUtils.isNullOrEmpty(morningstarRatingProps.morningStarRating)
		);
	}
	if (dataType === 'app-asset') {
		return (
			!common.commonUtils.isNullOrUndefined(appAssetProps) &&
			(
				!common.commonUtils.isNullOrEmpty(appAssetProps.src) ||
				!common.commonUtils.isNullOrEmpty(appAssetProps.asset)
			)
		)
	}
	if (dataType === 'grouped-list') {
		return (
			!common.commonUtils.isNullOrUndefined(groupedListProps) &&
			!common.commonUtils.isNullOrEmpty(groupedListProps.items)
		);
	}
	if (dataType === 'document-tiles') {
		return (
			!common.commonUtils.isNullOrUndefined(documentTilesProps) &&
			!common.commonUtils.isNullOrEmpty(documentTilesProps.tiles)
		);
	}
	if (dataType === 'link') {
		return !common.commonUtils.isNullOrUndefined(linkProps);
	}
	return !common.commonUtils.isNullOrEmpty(value);
};
